import { render, staticRenderFns } from "./ChatGPTActionDetailPrompt.vue?vue&type=template&id=464590a6&"
import script from "./ChatGPTActionDetailPrompt.vue?vue&type=script&lang=js&"
export * from "./ChatGPTActionDetailPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports